/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { MdEventRepeat } from "react-icons/md";
import { useAuth } from "../../../../Providers/Auth";
import mixpanel from "mixpanel-browser";
import { useState, useEffect } from "react";
import { useInfluencer } from "@/Providers/Influencer";
import { useGeneralSettings } from "@/Providers/General";
import { FaPlus } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { Button } from "@/shadcnComponents/ui/button";

import { BsRepeat1 } from "react-icons/bs";
import { PiCalendar } from "react-icons/pi";
import { useStaticData } from "@/Providers/Data";

import {
  HowChipsWorks,
  Leaderboard,
} from "./DashboardComponents/DashboardOrganism/Leaderboard";
import MobileMenuBar from "@/Components/Menubar/MobileMenuBar";
import { DashboardSkeleton } from "@/Components/Loader/dashboardSkeleton";

import { AiAnalysisCollabCheck } from "./DashboardComponents/DashboardOrganism/AiAnalysisCollabCheck";
import {
  ActivateProfileCard,
  FeaturedCard,
  InfluencerDashboardChapterCard,
  InfluencerWAAndProfileStrength,
  LiveAnchorsCollabs,
  NoticeCard,
  ToolsCards,
} from "./DashboardComponents/DashboardOrganism/DashboardOrganism";
import {
  PlatformInfoCard,
  SocialFieldCard,
} from "./DashboardComponents/DashboardMolecules";
import {
  AddDataCard,
  ChipsCard,
  getPlatformColor,
} from "./DashboardComponents/DashboardAtoms";

export const Dashboard = () => {
  const authState = useAuth();
  const influencerState = useInfluencer();
  const generalState = useGeneralSettings();
  const dataState = useStaticData();
  const [chipsData, setChipsData] = useState({});
  const navigate = useNavigate();
  const [dashboardLoading, setDashboardLoading] = useState(false);
  const [openChipsInfo, setOpenChipsInfo] = useState(false);

  const [refetchUserData, setRefetchUserData] = useState(true);
  const [InfluData, setInfluData] = useState<any>({});
  const [TempInfluData, setTempInfluData] = useState<TempInfluData>();
  const [influContentCategory, SetInfluContentCategory] = useState<string[]>();

  //master data
  const [masterContentCategory, setMasterContentCategory] = useState([]);
  const [masterContentFormat, setMasterContentFormat] = useState([]);
  const [masterAudienceTypes, setMasterAudienceTypes] = useState([]);
  const [masterAudiencePlatforms, setMasterAudiencePlatforms] = useState([]);
  const [masterCollabGoals, setMasterCollabGoals] = useState([]);
  const [masterMonetizationPlatform, setMasterMonetizationPlatform] = useState(
    []
  );
  const [masterMonetizationServices, setMasterMonetizationServices] = useState(
    []
  );

  const [allSocialPlatform] = useState([
    {
      socialPlatformName: "Instagram",
      socialPlatformLink:
        "https://anchors-collab.s3.ap-south-1.amazonaws.com/AudiencePlatform/Instagram.svg",
    },
    {
      socialPlatformName: "LinkedIn",
      socialPlatformLink:
        "https://anchors-collab.s3.ap-south-1.amazonaws.com/AudiencePlatform/LinkedIn.svg",
    },
    {
      socialPlatformName: "Telegram",
      socialPlatformLink:
        "https://anchors-collab.s3.ap-south-1.amazonaws.com/AudiencePlatform/Telegram.svg",
    },
    {
      socialPlatformName: "Facebook",
      socialPlatformLink:
        "https://anchors-collab.s3.ap-south-1.amazonaws.com/AudiencePlatform/Facebook.svg",
    },
    {
      socialPlatformName: "WhatsApp",
      socialPlatformLink:
        "https://anchors-collab.s3.ap-south-1.amazonaws.com/AudiencePlatform/Whatsapp.svg",
    },
    {
      socialPlatformName: "YouTube",
      socialPlatformLink:
        "https://anchors-collab.s3.ap-south-1.amazonaws.com/AudiencePlatform/Youtube.svg",
    },
    {
      socialPlatformName: "LinkTree",
      socialPlatformLink:
        "https://anchors-collab.s3.ap-south-1.amazonaws.com/MasterData-Collab/Linktree_logo.svg",
    },
    {
      socialPlatformName: "Twitter",
      socialPlatformLink:
        "https://anchors-collab.s3.ap-south-1.amazonaws.com/MasterData-Collab/twitter_logo.svg",
    },
  ]);

  const getPlatformIcon = (platformName) => {
    const OriginalName = getPlatformNameByFollower(platformName);
    const icon = allSocialPlatform?.find((item) => {
      if (item?.socialPlatformName?.includes(OriginalName))
        return item?.socialPlatformLink;
    });
    return icon?.socialPlatformLink;
  };
  const getPlatformNameByFollower = (value) => {
    if (value === "insta") {
      return "Instagram";
    } else if (value === "linkedin") {
      return "LinkedIn";
    } else if (value === "telegram") {
      return "Telegram";
    } else if (value === "fb") {
      return "Facebook";
    } else if (value === "whatsapp") {
      return "WhatsApp";
    } else if (value === "youTube") {
      return "YouTube";
    } else if (value === "linktree") {
      return "LinkTree";
    } else if (value === "twitter") {
      return "Twitter";
    }
  };

  useEffect(() => {
    if (refetchUserData) {
      mixpanel.track("Visited Influencer DashBoard");
      setDashboardLoading(true);

      influencerState.getPersonalInfo().then((e) => {
        setDashboardLoading(false);
        setRefetchUserData(false);
        if (e.success) {
          setInfluData(e);
        }
      });
    }
  }, [refetchUserData]);
  useEffect(() => {
    dataState?.getDataFromType("Influencer Chips").then((e) => {
      setChipsData(e[0]);
    });
    dataState?.getNewDataFromType("Content Type").then((e) => {
      setMasterContentCategory(e);
    });
    dataState?.getNewDataFromType("Content Format").then((e) => {
      setMasterContentFormat(e);
    });
    dataState?.getNewDataFromType("lkd_super_master_audienceType").then((e) => {
      setMasterAudienceTypes(e);
    });
    dataState?.getNewDataFromType("Audience Platform").then((e) => {
      setMasterAudiencePlatforms(e);
    });
    dataState?.getNewDataFromType("Goal / KPI").then((e) => {
      setMasterCollabGoals(e);
    });
    dataState?.getNewDataFromType("Platform Name").then((e) => {
      setMasterMonetizationPlatform(e);
    });
    dataState?.getNewDataFromType("Services list").then((e) => {
      setMasterMonetizationServices(e);
    });
  }, []);
  useEffect(() => {
    setDashboardLoading(true);
    const getTempInfluencerData = async () => {
      await influencerState
        .getTempInfluencerLinkedinProfileFromSlug(authState?.loggedUser?.slug)
        .then((resData) => {
          if (resData.success) {
            setTempInfluData(resData?.LinkedinAnalysis);
            SetInfluContentCategory(resData?.ContentCategory);
            setDashboardLoading(false);
          } else {
            alert(resData?.error || "Some Error occurred!");
            navigate("/");
          }
        });
    };
    getTempInfluencerData();
  }, []);
  useEffect(() => {
    const updateData = async () => {
      if (refetchUserData) return; // Skip if already fetching

      let shouldRefetch = false;

      // Handle categories update
      if (
        !InfluData?.data4?.categories?.length &&
        influContentCategory?.length
      ) {
        await influencerState?.updateContentInfo({
          categories: influContentCategory,
        });
        shouldRefetch = true;
      }

      // Handle personal info updates
      if (TempInfluData) {
        const updates: Record<string, any> = {};

        if (!InfluData?.data?.tagline && TempInfluData.tagline) {
          updates.tagline = TempInfluData.tagline;
        }
        if (!InfluData?.data?.linkedinLink && TempInfluData.profile_url) {
          updates.linkedinLink = TempInfluData.profile_url;
        }
        if (!InfluData?.data?.gender && TempInfluData.gender) {
          updates.gender = TempInfluData.gender;
        }
        if (
          !InfluData?.data?.followers?.linkedin &&
          TempInfluData.followers > 0
        ) {
          updates.followers = {
            linkedin: TempInfluData.followers,
          };
        }
        // Only make the API call if there are updates
        if (Object.keys(updates).length > 0) {
          await influencerState?.updatePersonalInfo(updates);
          shouldRefetch = true;
        }
      }

      // Trigger refetch only once if needed
      if (shouldRefetch) {
        setRefetchUserData(true);
      }
    };

    updateData();
  }, [InfluData, TempInfluData, influContentCategory]);
  //  real time chips changes ------------------
  const GoThroughArray = (arr: any[], stringName: string) => {
    let chips: number = 0;

    if (arr.length > 0) {
      if (typeof arr[0] === "object") {
        // means the elements e=inside the array are objects ------------

        for (let index = 0; index < arr.length; index++) {
          const element = arr[index];
          const credits = GoThroughObjects(element, stringName);
          chips += credits;
        }
      } else {
        if (arr.filter((e) => e?.length > 0)?.length > 0) {
          if (chipsData[stringName]) {
            chips += chipsData[stringName];
          }
        }
      }
    }
    return chips;
  };

  const GoThroughObjects = (obj: object, stringName: string) => {
    let chips: number = 0;

    const keysArr = Object.keys(obj || {});
    const ValuesArr = Object.values(obj || {});

    for (let index = 0; index < ValuesArr.length; index++) {
      const element = ValuesArr[index];

      // is an array ---------------
      if (Array.isArray(element)) {
        const credits = GoThroughArray(
          element,
          stringName + "." + keysArr[index]
        );
        chips += credits;
      }

      // is an object ----------------
      else if (typeof element === "object") {
        const credits = GoThroughObjects(
          element,
          stringName + "." + keysArr[index]
        );
        chips += credits;
      }

      // is a string ------------------
      else {
        // find the value and add in the chips
        if (element !== null && element !== "") {
          if (chipsData[stringName + "." + keysArr[index]]) {
            chips += chipsData[stringName + "." + keysArr[index]];
          }

          //  followers edge cases
          else if (
            (stringName + "." + keysArr[index]).includes("personal.followers")
          ) {
            chips += chipsData["social.followers"];
          }

          //  social links edge cases
          else if (
            [
              "personal.linkedinLink",
              "personal.twitterLink",
              "personal.instaLink",
              "personal.fbLink",
              "personal.telegramLink",
              "personal.whatsappLink",
              "personal.YouTubeLink",
              "personal.linkTreeLink",
            ].includes(stringName + "." + keysArr[index])
          ) {
            chips += chipsData["social.link"];
          }
        }
      }
    }

    return chips;
  };

  function CountTheChips(data: object | [], stringName: string) {
    let credits: number = 0;

    // check is the data is objet or array
    if (Array.isArray(data)) {
      credits = GoThroughArray(data, stringName);
    }

    // is an object -------------
    else {
      credits = GoThroughObjects(data, stringName);
    }

    return credits;
  }

  useEffect(() => {
    const cfd1 = CountTheChips(InfluData?.data, "personal");
    const cfd2 = CountTheChips(InfluData?.data2?.data, "collab");
    const cfd3 = CountTheChips(InfluData?.data3?.data, "monetisation");
    const cfd4 = CountTheChips(InfluData?.data4, "content");
    const cfd5 = CountTheChips(InfluData?.data5, "audience");
    const cfd6 = CountTheChips(InfluData?.data6, "charges");
    const cdf7 =
      authState?.loggedUser?.referralCount * parseInt(chipsData?.["referral"]);
    generalState?.setSidebarChipsCount({
      profile: cfd1,
      collab: cfd2,
      monetization: cfd3,
      content: cfd4,
      audience: cfd5,
      charges: cfd6,
      referral: cdf7,
    });
  }, [InfluData]);
  return (
    <>
      {dashboardLoading ? (
        <DashboardSkeleton hideNavbar={true} hideSidebar={true} />
      ) : (
        <>
          <MobileMenuBar />
          {openChipsInfo && (
            <HowChipsWorks onClick={() => setOpenChipsInfo(false)} />
          )}
          <div className="w-full relative  h-max items-start flex p-[16px] md:p-[40px]  pb-[100px] md:pb-[16px] gap-[15px] ">
            <div className="w-full md:w-[80%] space-y-4">
              {/* Activate Your Profile */}
              <ActivateProfileCard />

              {/* Notice Card */}
              <NoticeCard />

              {/* Featured Card */}
              {authState?.loggedUser?.featuredData?.value && <FeaturedCard />}

              {/* Your live collabs ---------------- */}
              <LiveAnchorsCollabs />

              {/* Location Chapter card */}
              <InfluencerDashboardChapterCard />

              {/* Profile Strength ----------------- */}
              <InfluencerWAAndProfileStrength
                isProfileActive={
                  authState?.loggedUser?.activePlan ? true : false
                }
                currentProfileStrength={
                  authState?.loggedUser?.profileStrengthStatus
                }
              />

              {/* AI Analysis Collab Check --------------- */}
              <AiAnalysisCollabCheck />

              <iframe
                src="https://lu.ma/embed/event/evt-gRkR86REGqK5xWn/simple"
                width="100%"
                height="380"
                frameBorder="0"
                style={{
                  border: "1px solid #bfcbda88",
                  borderRadius: "4px",
                }}
                allowFullScreen
                aria-hidden="false"
                tabIndex={0}
              />

              {/* Profile Building Cards ------------------ */}
              <div className="flex flex-wrap gap-4 ">
                {/* personal info ------HIDDEN */}
                {InfluData?.data ? (
                  <div className="min-w-[296px] hidden min-h-[317px] z-[0] flex-col justify-between items-start flex-[1_0_0] self-stretch p-4 border border-neutral-800 rounded-md border-solid bg-[rgba(255, 255, 255, 0.02)] relative ">
                    <div className="absolute z-[-1] top-[50%] translate-y-[-50%] ">
                      <img
                        src="https://anchors-collab.s3.ap-south-1.amazonaws.com/assets/gradient.svg"
                        alt=""
                      />
                    </div>
                    <div className="flex flex-col items-start gap-5 self-stretch">
                      <div className="flex flex-col items-start gap-1 self-stretch;">
                        <span className="text-white text-center text-sm not-italic font-semibold leading-5">
                          {InfluData?.data?.name}
                        </span>
                        <span className="text-[#A6A6A6] text-sm italic font-normal leading-5 tracking-[0.14px]">
                          {InfluData?.data?.tagline || TempInfluData?.tagline}
                        </span>
                      </div>
                      <div className="flex items-start content-start gap-2.5 self-stretch flex-wrap">
                        {InfluData?.data?.followers &&
                          Object.keys(InfluData?.data?.followers)?.map(
                            (item, index) => {
                              return (
                                InfluData?.data?.followers?.[item] && (
                                  <div
                                    key={index}
                                    className={`min-w-[80px] flex justify-center items-center gap-2 rounded border px-2 py-1.5 border-solid  text-white text-center text-xs not-italic font-normal leading-5
                            ${getPlatformColor(getPlatformNameByFollower(item))}
                            `}
                                  >
                                    <img
                                      className=" w-[18px] h-[18px] "
                                      src={getPlatformIcon(item)}
                                      alt=""
                                    />
                                    {InfluData?.data?.followers?.[item]}
                                  </div>
                                )
                              );
                            }
                          )}
                      </div>
                      <div
                        onClick={() => {
                          mixpanel.track("Personal Info - Add - Clicked");
                          navigate("/influencer/build_profile?page=profile");
                        }}
                        className=" cursor-pointer flex justify-around items-center gap-2 rounded border px-2 py-1.5 border-dashed border-[#A3A3A3]  text-neutral-400 text-center text-xs not-italic font-normal leading-[normal]"
                      >
                        <FaPlus /> Add
                      </div>
                    </div>
                    <span className="text-[#A6A6A6] text-sm not-italic font-medium leading-5 tracking-[0.14px]">
                      Earned 💸 {generalState?.SidebarChipsCount?.profile || 0}{" "}
                      chips
                    </span>
                  </div>
                ) : (
                  <AddDataCard
                    action={() =>
                      navigate("/influencer/build_profile?page=content")
                    }
                    title={"Add Profile"}
                    description={
                      "💰 Show your ability to connect with & convert your followers, making you a valuable brand partner"
                    }
                  />
                )}
                {/* content info ----------HIDDEN */}
                {InfluData?.data4 || influContentCategory ? (
                  <div className="min-w-[296px] hidden min-h-[317px] z-[0]  flex-col justify-between gap-[30px] items-start flex-[1_0_0] self-stretch p-4 border border-neutral-800 rounded-md border-solid bg-[rgba(255, 255, 255, 0.02)] relative ">
                    <div className="absolute z-[-1] top-[50%] translate-y-[-50%] ">
                      <img
                        src="https://anchors-collab.s3.ap-south-1.amazonaws.com/assets/gradient.svg"
                        alt=""
                      />
                    </div>

                    <div className="flex flex-col items-start gap-1 self-stretch">
                      <span className="text-white text-center text-sm not-italic font-semibold leading-5">
                        Content Categories
                      </span>
                      <div className="flex items-start content-start gap-[6px_8px] self-stretch flex-wrap">
                        {(
                          InfluData?.data4?.categories || influContentCategory
                        )?.map((item, index) => {
                          return (
                            <ChipsCard
                              value={
                                masterContentCategory?.find(
                                  (category) => category?._id === item
                                )?.categoryName
                              }
                              key={`content_category_${index}`}
                            />
                          );
                        })}
                      </div>
                    </div>
                    <div className="flex flex-col items-start gap-1 self-stretch">
                      <span className="text-white text-center text-sm not-italic font-semibold leading-5">
                        Content Formats
                      </span>
                      <div className="flex items-start content-start gap-[6px_8px] self-stretch flex-wrap">
                        {InfluData?.data4?.formats?.map((item, index) => {
                          return (
                            <ChipsCard
                              key={`content_formats_${index}`}
                              value={
                                masterContentFormat?.find(
                                  (category) => category?._id === item
                                )?.contentFormatName
                              }
                            />
                          );
                        })}
                        <div
                          onClick={() => {
                            mixpanel.track("Content Formats - Add - Clicked");
                            navigate("/influencer/build_profile?page=content");
                          }}
                          className=" flex justify-around cursor-pointer items-center gap-2 rounded border px-2 py-1.5 border-dashed border-[#A3A3A3]  text-neutral-400 text-center text-xs not-italic font-normal leading-[normal]"
                        >
                          <FaPlus /> Add
                        </div>
                      </div>
                    </div>

                    <span className="text-[#A6A6A6] text-sm not-italic font-medium leading-5 tracking-[0.14px]">
                      Earned 💸 {generalState?.SidebarChipsCount?.content || 0}{" "}
                      chips
                    </span>
                  </div>
                ) : (
                  <AddDataCard
                    action={() =>
                      navigate("/influencer/build_profile?page=content")
                    }
                    title={"Add Content Info"}
                    description={
                      "💰 Show your ability to connect with & convert your followers, making you a valuable brand partner"
                    }
                  />
                )}
                {/* audience info ------HIDDEN */}
                <div className="hidden">
                  {InfluData?.data5?.types?.length ||
                  InfluData?.data5?.platforms?.length ? (
                    <div className="min-w-[296px] min-h-[317px] z-[0] gap-[30px] flex flex-col justify-between items-start flex-[1_0_0] self-stretch p-4 border border-neutral-800 rounded-md border-solid bg-[rgba(255, 255, 255, 0.02)] relative ">
                      <div className="absolute z-[-1] top-[50%] translate-y-[-50%] ">
                        <img
                          src="https://anchors-collab.s3.ap-south-1.amazonaws.com/assets/gradient.svg"
                          alt=""
                        />
                      </div>
                      {InfluData?.data5?.types?.length && (
                        <div className="flex items-start content-start gap-[6px_8px] self-stretch flex-wrap">
                          <span className="text-white text-center text-sm not-italic font-semibold leading-5">
                            Audience Types
                          </span>
                          <div className="flex items-start content-start gap-[6px_8px] self-stretch flex-wrap">
                            {InfluData?.data5?.types?.map((item, index) => {
                              return (
                                <ChipsCard
                                  key={`audience_type_${index}`}
                                  value={
                                    masterAudienceTypes?.find(
                                      (audience) => audience?._id === item
                                    )?.LkdAudienceTypeName
                                  }
                                />
                              );
                            })}
                            <div
                              onClick={() => {
                                mixpanel.track(
                                  "Audience Types - Add - Clicked"
                                );
                                navigate(
                                  "/influencer/build_profile?page=audience"
                                );
                              }}
                              className="flex cursor-pointer justify-around items-center gap-2 rounded border px-2 py-1.5 border-dashed border-[#A3A3A3]  text-neutral-400 text-center text-xs not-italic font-normal leading-[normal]"
                            >
                              <FaPlus /> Add
                            </div>
                          </div>
                        </div>
                      )}
                      {InfluData?.data5?.platforms &&
                        InfluData?.data5?.platforms?.length > 0 && (
                          <div className="flex flex-col items-start gap-2 self-stretch">
                            <span className="text-white text-center text-sm not-italic font-semibold leading-5">
                              Platform Presence
                            </span>
                            <div
                              style={{ scrollbarWidth: "none" }}
                              className="flex flex-col max-h-[107px] self-stretch items-start gap-2 overflow-x-auto"
                            >
                              {InfluData?.data5?.platforms
                                ?.filter(
                                  (item) =>
                                    item?.platform?.length > 1 && item?.audience
                                )
                                .map((item, index) => {
                                  return (
                                    <SocialFieldCard
                                      key={`audience_platform_${index}`}
                                      link={item?.link}
                                      platform={
                                        masterAudiencePlatforms?.find(
                                          (platform) =>
                                            platform?._id === item?.platform
                                        )?.audiencePlatformName
                                      }
                                      audience={item?.audience}
                                      icon={
                                        masterAudiencePlatforms?.find(
                                          (platform) =>
                                            platform?._id === item?.platform
                                        )?.audiencePlatformIcon
                                      }
                                    />
                                  );
                                })}
                            </div>
                            <div
                              onClick={() => {
                                mixpanel.track(
                                  "Platform Presence - Add - Clicked"
                                );
                                navigate(
                                  "/influencer/build_profile?page=audience"
                                );
                              }}
                              className="flex gap-2 cursor-pointer justify-around items-center  rounded border px-2 py-1.5 border-dashed border-[#A3A3A3]  text-neutral-400 text-center text-xs not-italic font-normal leading-[normal]"
                            >
                              <FaPlus /> Add
                            </div>
                          </div>
                        )}

                      <span className="text-[#A6A6A6] text-sm not-italic font-medium leading-5 tracking-[0.14px]">
                        Earned 💸{" "}
                        {generalState?.SidebarChipsCount?.audience || 0} chips
                      </span>
                    </div>
                  ) : (
                    <AddDataCard
                      action={() =>
                        navigate("/influencer/build_profile?page=audience")
                      }
                      title={"Add Audience"}
                      description={
                        "🌟 Brands are looking for creators who resonate with their target audience!"
                      }
                    />
                  )}
                </div>

                {/* collab info */}
                {InfluData?.data2?.data?.length > 0 ? (
                  <div className="min-w-[296px] min-h-[317px] z-[0] flex flex-col gap-[30px] justify-between items-start flex-[1_0_0] self-stretch p-4 border border-neutral-800 rounded-md border-solid bg-[rgba(255, 255, 255, 0.02)] relative ">
                    <div className="absolute z-[-1] top-[50%] translate-y-[-50%] ">
                      <img
                        src="https://anchors-collab.s3.ap-south-1.amazonaws.com/assets/gradient.svg"
                        alt=""
                      />
                    </div>
                    {InfluData?.data2?.data && (
                      <div className="flex flex-col items-start gap-3 self-stretch">
                        <span className="text-white text-center text-sm not-italic font-semibold leading-5">
                          Collab Profile
                        </span>
                        <div
                          style={{ scrollbarWidth: "none" }}
                          className="flex max-h-[177px] overflow-x-auto flex-col items-start gap-3 self-stretch"
                        >
                          {InfluData?.data2?.data
                            ?.filter((item) => item?.companyName?.length > 1)
                            .map((item, index) => {
                              return (
                                <PlatformInfoCard
                                  platformName={item?.companyName}
                                  platformLink={item?.companyUrl}
                                  redirectTo={
                                    "/influencer/build_profile?page=collab"
                                  }
                                  key={index}
                                  goals={item?.goals?.map((goal) => {
                                    const GoalName = masterCollabGoals?.find(
                                      (masterGoal) => masterGoal?._id === goal
                                    );
                                    return GoalName?.CollabGoalsName;
                                  })}
                                  audience={undefined}
                                  icon={undefined}
                                  collabId={item?._id}
                                  link={item?.collabVerification?.link}
                                  status={item?.collabVerification?.status}
                                />
                              );
                            })}
                        </div>
                        <Button
                          onClick={() => {
                            mixpanel.track("Collab Profile - Add - Clicked");
                            navigate("/influencer/build_profile?page=collab");
                          }}
                          variant="outline"
                          className="rounded gap-2 bg-transparent w-full text-neutral-400 text-center text-xs not-italic font-normal leading-[normal] border border-neutral-400 border-dashed"
                        >
                          <FaPlus /> Add
                        </Button>
                      </div>
                    )}
                    <span className="text-[#A6A6A6] text-sm not-italic font-medium leading-5 tracking-[0.14px]">
                      Earned 💸 {generalState?.SidebarChipsCount?.collab || 0}{" "}
                      chips
                    </span>
                  </div>
                ) : (
                  <AddDataCard
                    action={() =>
                      navigate("/influencer/build_profile?page=collab")
                    }
                    title={"Showcase Collaborations"}
                    description={
                      "🫱🏼‍🫲🏽 Add details of your past collaborations with brands to demonstrate your versatility"
                    }
                  />
                )}
                {/* monetization  info */}
                {InfluData?.data3?.data?.length ? (
                  <div className="min-w-[296px] min-h-[317px] z-[0] gap-[30px] flex flex-col justify-between items-start flex-[1_0_0] self-stretch p-4 border border-neutral-800 rounded-md border-solid bg-[rgba(255, 255, 255, 0.02)] relative ">
                    <div className="absolute z-[-1] top-[50%] translate-y-[-50%] ">
                      <img
                        src="https://anchors-collab.s3.ap-south-1.amazonaws.com/assets/gradient.svg"
                        alt=""
                      />
                    </div>
                    {InfluData?.data3?.data?.length > 0 && (
                      <div className="flex flex-col items-start gap-3 self-stretch">
                        <span className="text-white text-center text-sm not-italic font-semibold leading-5">
                          Monetization Avenues
                        </span>
                        <div
                          style={{ scrollbarWidth: "none" }}
                          className="flex max-h-[177px] overflow-x-auto flex-col items-start gap-3 self-stretch"
                        >
                          {InfluData?.data3?.data
                            ?.filter((item) => item?.platformName?.length > 1)
                            .map((item, index) => {
                              return (
                                <PlatformInfoCard
                                  platformName={
                                    masterMonetizationPlatform?.find(
                                      (platform) =>
                                        platform?._id === item?.platformName
                                    )?.monetizationPlatformName
                                  }
                                  platformLink={item?.profileLink}
                                  redirectTo={
                                    "/influencer/build_profile?page=monetization"
                                  }
                                  key={index}
                                  goals={item?.methods?.map((method) => {
                                    const methodName =
                                      masterMonetizationServices?.find(
                                        (masterMethod) =>
                                          masterMethod?._id === method
                                      );
                                    return methodName?.monetizationServiceName;
                                  })}
                                  audience={item?.paidAudience}
                                  icon={
                                    masterMonetizationPlatform?.find(
                                      (platform) =>
                                        platform?._id === item?.platformName
                                    )?.monetizationPlatformIcon
                                  }
                                />
                              );
                            })}
                        </div>
                        <Button
                          onClick={() => {
                            mixpanel.track(
                              "Monetization Avenues - Add - Clicked"
                            );
                            navigate(
                              "/influencer/build_profile?page=monetization"
                            );
                          }}
                          variant="outline"
                          className="flex justify-center items-center self-stretch px-2 py-1.5 rounded gap-2 bg-transparent w-full text-neutral-400 text-center text-xs not-italic font-normal leading-[normal] border border-neutral-400 border-dashed"
                        >
                          <FaPlus /> Add
                        </Button>
                      </div>
                    )}
                    <span className="text-[#A6A6A6] text-sm not-italic font-medium leading-5 tracking-[0.14px]">
                      Earned 💸{" "}
                      {generalState?.SidebarChipsCount?.monetization || 0} chips
                    </span>
                  </div>
                ) : (
                  <AddDataCard
                    action={() =>
                      navigate("/influencer/build_profile?page=monetization")
                    }
                    title={"Add Monetisation Platforms"}
                    description={
                      "💰 Show your ability to build a paid audience, making you a valuable brand partner"
                    }
                  />
                )}

                {/* charges info */}
                {InfluData?.data6 ? (
                  <div className="min-w-[296px] min-h-[317px] z-[0]  flex flex-col justify-between items-start flex-[1_0_0] self-stretch p-4 border border-neutral-800 rounded-md border-solid bg-[rgba(255, 255, 255, 0.02)] relative ">
                    <div className="absolute z-[-1] top-[50%] translate-y-[-50%] ">
                      <img
                        src="https://anchors-collab.s3.ap-south-1.amazonaws.com/assets/gradient.svg"
                        alt=""
                      />
                    </div>
                    {InfluData?.data6 && (
                      <div className="flex flex-col items-start gap-3 self-stretch">
                        <span className="text-white text-center text-sm not-italic font-semibold leading-5">
                          Collab Rates
                        </span>
                        <div className="flex items-start flex-wrap gap-2 self-stretch">
                          <div className="flex flex-col justify-center items-center gap-2 flex-[1_0_0] p-2 rounded border border-neutral-800 border-solid bg-[#2b1d1f]">
                            <div className="flex justify-center items-center gap-2 ">
                              <BsRepeat1 size={16} color="#fff" />
                              <span className="text-white text-sm not-italic font-semibold leading-[normal]">
                                Single
                              </span>
                            </div>
                            <span className="text-neutral-400 text-xs not-italic font-medium leading-[normal]">{`₹${
                              InfluData?.data6?.PostMinPrice || 0
                            } - ₹${InfluData?.data6?.PostMaxPrice || 0}`}</span>
                          </div>
                          <div className="flex flex-col justify-center items-center gap-2 flex-[1_0_0] p-2 rounded border border-neutral-800 border-solid bg-[#2b1d1f]">
                            <div className="flex justify-center items-center gap-2 ">
                              <MdEventRepeat size={16} color="#fff" />
                              <span className="text-white text-sm not-italic font-semibold leading-[normal]">
                                Monthly
                              </span>
                            </div>
                            <span className="text-neutral-400 text-xs not-italic font-medium leading-[normal]">{`₹${
                              InfluData?.data6?.MonthlyMinPrice || 0
                            } - ₹${
                              InfluData?.data6?.MonthlyMaxPrice || 0
                            }`}</span>
                          </div>
                          <div className="flex flex-col justify-center items-center gap-2 flex-[1_0_0] p-2 rounded border border-neutral-800 border-solid bg-[#2b1d1f]">
                            <div className="flex justify-center items-center gap-2 ">
                              <PiCalendar size={16} color="#fff" />
                              <span className="text-white text-sm not-italic font-semibold leading-[normal]">
                                Yearly
                              </span>
                            </div>
                            <span className="text-neutral-400 text-xs not-italic font-medium leading-[normal]">{`₹${
                              InfluData?.data6?.YearlyMinPrice || 0
                            } - ₹${
                              InfluData?.data6?.YearlyMaxPrice || 0
                            }`}</span>
                          </div>
                        </div>
                        <span
                          onClick={() => {
                            mixpanel.track(
                              "Collab Rates - View Details - Clicked"
                            );
                            navigate("/influencer/build_profile?page=pricing");
                          }}
                          className=" w-full text-xs font-normal leading-[14.52px] text-center text-[#E2E8F0] cursor-pointer "
                        >
                          View Details
                        </span>
                      </div>
                    )}
                    <span className="text-[#A6A6A6] text-sm not-italic font-medium leading-5 tracking-[0.14px]">
                      Earned 💸 {generalState?.SidebarChipsCount?.charges || 0}{" "}
                      chips
                    </span>
                  </div>
                ) : (
                  <AddDataCard
                    action={() =>
                      navigate("/influencer/build_profile?page=pricing")
                    }
                    title={"Set Your Rates"}
                    description={
                      "🤑 Set clear pricing, attract ideal brands, & get paid what you're worth"
                    }
                  />
                )}
              </div>

              <ToolsCards />
            </div>

            {/* my earnings */}
            <div className="hidden md:block sticky top-10 space-y-10">
              {/* {!authState?.loggedUser?.activePlan && (
                <Button
                  className="w-full"
                  variant="destructive"
                  onClick={() => {
                    mixpanel.track(
                      "Influencer Dashboard : Preview Profile : clicked"
                    );
                    navigate(`/influencer/edit/?mode=preview`);
                  }}
                >
                  Preview Profile
                </Button>
              )} */}
              <div
                style={{
                  background:
                    "linear-gradient(to right, #FEAC5E, #C779D0, #4BC0C8)",
                }}
                className="min-w-[200px]  h-auto py-[1px] relative flex items-start justify-center rounded-md"
              >
                <div className="bg-[#232323] flex flex-col min-w-[198px] max-w-[198px] p-4  gap-[12px] text-[white]  rounded-md">
                  <div className="flex flex-col items-center gap-1 self-stretch">
                    <span className="text-white text-center text-sm not-italic font-bold leading-5">
                      My Chips
                    </span>
                    <span className="flex justify-center items-center self-stretch">
                      <img
                        className=" w-[32px] h-[32px] "
                        src="https://anchors-collab.s3.ap-south-1.amazonaws.com/assets/f06623be8acc04b336d91541c5dccaec.gif"
                        alt=""
                      />
                      {generalState.SidebarChipsCount.profile +
                        generalState.SidebarChipsCount.collab +
                        generalState.SidebarChipsCount.monetization +
                        generalState.SidebarChipsCount.content +
                        generalState.SidebarChipsCount.audience +
                        generalState.SidebarChipsCount.charges +
                        generalState.SidebarChipsCount.referral >
                      authState?.loggedUser?.totalChips
                        ? generalState.SidebarChipsCount.profile +
                          generalState.SidebarChipsCount.collab +
                          generalState.SidebarChipsCount.monetization +
                          generalState.SidebarChipsCount.content +
                          generalState.SidebarChipsCount.audience +
                          generalState.SidebarChipsCount.charges +
                          generalState.SidebarChipsCount.referral
                        : authState?.loggedUser?.totalChips}
                    </span>
                  </div>
                  <span className="text-[#A6A6A6] text-center text-[10px] not-italic font-normal ">
                    Maximum chips collected are{" "}
                    {authState?.loggedUser?.featuredData?.topCreatorChips}
                    . <br /> Can you reach there?
                  </span>

                  <div
                    className="text-[#EEE] text-center [text-shadow:0px_4px_4px_rgba(0,_0,_0,_0.25)] font-[Inter] text-[10px] not-italic font-extralight leading-[normal] [text-decoration-line:underline] cursor-pointer"
                    onClick={() => {
                      mixpanel.track(
                        "Dashboard Info - How chips can be increased? - Clicked"
                      );
                      setOpenChipsInfo(true);
                    }}
                  >
                    How chips can be increased?
                  </div>
                </div>
              </div>

              {/* Leaderboard */}
              <Leaderboard />
            </div>
          </div>
        </>
      )}
    </>
  );
};
